<app-side-menu>
  <div class="purchase-order-form-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-outline-secondary me-3"
              (click)="cancel()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-shopping-cart me-3"></i>
                {{ formPageTitle }}
              </h1>
              <p class="page-subtitle">{{ formPageSubtitle }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário -->
    <div class="row">
      <div class="col-12">
        <div class="purchase-order-form-card">
          <!-- Loading overlay (igual ao Customers) -->
          <div *ngIf="isLoading" class="loading-overlay">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <app-form-shell
            [tabs]="availableTabs"
            [activeTab]="activeTab"
            (tabChange)="selectTab($event)">
          </app-form-shell>

          <!-- Step 1: Informações Básicas -->
          <div *ngIf="activeTab === 'basic'" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h3>
            
            <div [formGroup]="formStep1" class="row g-3">
              <div class="col-md-4">
                <label for="orderNumber" class="form-label">Número do Pedido</label>
                <input 
                  type="text" 
                  id="orderNumber"
                  class="form-control"
                  formControlName="orderNumber"
                  readonly>
              </div>
              
              <div class="col-md-4">
                <label for="priority" class="form-label">Prioridade *</label>
                <select 
                  id="priority"
                  class="form-select"
                  formControlName="priority"
                  [class.is-invalid]="isFieldInvalid('priority', 1)">
                  <option value="">Selecione...</option>
                  <option *ngFor="let option of priorityOptions" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('priority', 1)">
                  {{ getFieldError('priority', 1) }}
                </div>
              </div>

              <div class="col-md-4">
                <label for="status" class="form-label">Status {{ isEditMode ? '*' : '' }}</label>
                <select 
                  id="status"
                  class="form-select"
                  formControlName="status"
                  [class.is-invalid]="isFieldInvalid('status', 1)"
                  [disabled]="loadingStatuses">
                  <option value="">Selecione...</option>
                  <option *ngFor="let status of statusOptions" [value]="status.name">
                    {{ status.name }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('status', 1)">
                  {{ getFieldError('status', 1) }}
                </div>
                <div *ngIf="loadingStatuses" class="form-text">
                  <i class="fas fa-spinner fa-spin me-1"></i> Carregando status...
                </div>
                <small class="text-muted" *ngIf="!isEditMode">Na criação, o pedido será definido como &quot;Solicitado&quot;.</small>
              </div>
              
              <div class="col-md-4">
                <label for="expectedDeliveryDate" class="form-label">Data de Entrega Esperada</label>
                <input 
                  type="date" 
                  id="expectedDeliveryDate"
                  class="form-control"
                  formControlName="expectedDeliveryDate">
              </div>
              
              <div class="col-12">
                <label for="description" class="form-label">Descrição</label>
                <textarea 
                  id="description"
                  class="form-control"
                  formControlName="description"
                  rows="3"
                  placeholder="Descrição geral do pedido de compra..."
                  [class.is-invalid]="isFieldInvalid('description', 1)"></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('description', 1)">
                  {{ getFieldError('description', 1) }}
                </div>
              </div>
            </div>
          </div>

          <!-- Step 2: Relacionamentos -->
          <div *ngIf="activeTab === 'relationships'" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-link me-2"></i>
              Relacionamentos
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-6">
                <label for="costCenterId" class="form-label">Centro de Custo *</label>
                <select 
                  id="costCenterId"
                  class="form-select"
                  formControlName="costCenterId"
                  [class.is-invalid]="isFieldInvalid('costCenterId', 2)">
                  <option value="">Selecione um centro de custo</option>
                  <option *ngFor="let costCenter of costCenters" [value]="costCenter.id">
                    {{ costCenter.name }}
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('costCenterId', 2)">
                  {{ getFieldError('costCenterId', 2) }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="deliveryWarehouseId" class="form-label">Armazém de Entrega</label>
                <select 
                  id="deliveryWarehouseId"
                  class="form-select"
                  formControlName="deliveryWarehouseId">
                  <option value="">Selecione um armazém</option>
                  <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
                    {{ warehouse.name }}
                  </option>
                </select>
              </div>

              <div class="col-12">
                <div class="alert alert-light border mb-0">
                  <i class="fas fa-info-circle me-2 text-primary"></i>
                  Neste novo fluxo, o fornecedor sera definido pela cotacao vencedora.
                </div>
              </div>
            </div>
          </div>

          <!-- Step 3: Entrega e Pagamento -->
          <div *ngIf="activeTab === 'delivery'" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-truck me-2"></i>
              Entrega e Pagamento
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-4">
                <label for="zipCode" class="form-label">CEP</label>
                <div class="input-group">
                  <input 
                    type="text" 
                    id="zipCode"
                    class="form-control"
                    formControlName="zipCode"
                    (input)="onZipCodeInput($event)"
                    placeholder="00000-000">
                  <button 
                    type="button" 
                    class="btn btn-outline-primary"
                    (click)="lookupCep()"
                    [disabled]="isCepLoading || !formStep3.get('zipCode')?.value">
                    <i class="fas fa-search me-1"></i>
                    Buscar CEP
                    <span *ngIf="isCepLoading" class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                  </button>
                </div>
                <small class="text-muted">Informe o CEP e clique em buscar para preencher o endereço.</small>
              </div>

              <div class="col-md-6">
                <label for="deliveryAddress" class="form-label">Endereço de Entrega</label>
                <input 
                  type="text" 
                  id="deliveryAddress"
                  class="form-control"
                  formControlName="deliveryAddress"
                  placeholder="Endereço específico para entrega...">
              </div>
              
              <div class="col-md-6">
                <label for="paymentTerms" class="form-label">Condições de Pagamento</label>
                <input 
                  type="text" 
                  id="paymentTerms"
                  class="form-control"
                  formControlName="paymentTerms"
                  placeholder="Ex: 30 dias, à vista, etc...">
              </div>
              
              <div class="col-12">
                <label for="deliveryInstructions" class="form-label">Instruções de Entrega</label>
                <textarea 
                  id="deliveryInstructions"
                  class="form-control"
                  formControlName="deliveryInstructions"
                  rows="3"
                  placeholder="Instruções específicas para a entrega..."></textarea>
              </div>
              
              <div class="col-12">
                <label for="notes" class="form-label">Observações</label>
                <textarea 
                  id="notes"
                  class="form-control"
                  formControlName="notes"
                  rows="4"
                  placeholder="Observações gerais sobre o pedido de compra..."></textarea>
              </div>
            </div>
          </div>

          <!-- Step 4: Itens do Pedido -->
          <div *ngIf="activeTab === 'items'" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-list me-2"></i>
              Itens do Pedido
              <span class="badge bg-secondary ms-2">{{ itemsFormArray.length }}</span>
            </h3>
            
            
            <div class="mb-3 d-flex align-items-center gap-3">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="addItem()">
                <i class="fas fa-plus me-2"></i>
                Adicionar Item
              </button>
              <span class="text-muted small" *ngIf="items.length === 0">
                <i class="fas fa-info-circle me-1"></i>
                Nenhum item cadastrado. Cadastre itens no módulo de Estoque para selecionar aqui.
              </span>
              <span class="text-muted small" *ngIf="items.length > 0">
                <i class="fas fa-box me-1"></i>
                {{ items.length }} produto(s) cadastrado(s) disponíveis
              </span>
            </div>
            
            <div class="table-responsive" [formGroup]="formStep4">
              <table class="table table-hover">
                <thead class="table-light">
                  <tr>
                    <th style="width: 30px;">#</th>
                    <th>Produto</th>
                    <th style="width: 100px;">Qtd</th>
                    <th style="width: 80px;">Unidade</th>
                    <th style="width: 120px;">Preço Unit.</th>
                    <th style="width: 120px;">Total</th>
                    <th style="width: 100px;">Ações</th>
                  </tr>
                </thead>
                <tbody formArrayName="items">
                  <tr *ngFor="let item of itemsFormArray.controls; let i = index" [formGroupName]="i">
                    <td class="text-center fw-bold">{{ i + 1 }}</td>
                    
                    <td>
                      <select 
                        class="form-select form-select-sm"
                        formControlName="itemId"
                        (change)="onItemSelected(i, $any($event.target).value)"
                        title="Selecione um item cadastrado">
                        <option [ngValue]="null">-- Selecione o produto --</option>
                        <option 
                          *ngFor="let prod of items" 
                          [ngValue]="prod.id">
                          {{ prod.code }} - {{ prod.name }}
                        </option>
                      </select>
                      <small class="text-muted d-block mt-1" *ngIf="item.get('productName')?.value">
                        {{ item.get('productCode')?.value }} · {{ item.get('productName')?.value }}
                      </small>
                    </td>
                    
                    <td>
                      <input 
                        type="number" 
                        class="form-control form-control-sm text-center"
                        formControlName="quantityRequested"
                        min="0.01"
                        step="0.01">
                    </td>
                    
                    <td>
                      <input 
                        type="text" 
                        class="form-control form-control-sm"
                        formControlName="unit"
                        placeholder="UN">
                    </td>
                    
                    <td>
                      <input 
                        type="number" 
                        class="form-control form-control-sm"
                        formControlName="estimatedUnitPrice"
                        min="0"
                        step="0.01"
                        placeholder="0,00">
                    </td>
                    
                    <td class="text-center">
                      <strong class="text-primary">
                        {{ formatCurrency(calculateItemTotal(i)) }}
                      </strong>
                    </td>
                    
                    <td>
                      <div class="btn-group btn-group-sm">
                        <button 
                          type="button" 
                          class="btn btn-outline-info"
                          (click)="duplicateItem(i)"
                          title="Duplicar">
                          <i class="fas fa-copy"></i>
                        </button>
                        <button 
                          type="button" 
                          class="btn btn-outline-danger"
                          (click)="removeItem(i)"
                          [disabled]="itemsFormArray.length === 1"
                          title="Remover">
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
                
                <tfoot class="table-light">
                  <tr>
                    <td colspan="5" class="text-end fw-bold">Total Geral:</td>
                    <td class="text-center fw-bold text-primary fs-5">
                      {{ formatCurrency(calculateOrderTotal()) }}
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <!-- Navegação dos Steps -->
          <div class="step-navigation">
            <div class="d-flex gap-2">
              <button 
                *ngIf="isFirstTab()"
                type="button" 
                class="btn btn-outline-secondary"
                (click)="cancel()">
                <i class="fas fa-arrow-left me-2"></i>
                Voltar
              </button>
              <button 
                *ngIf="!isFirstTab()"
                type="button" 
                class="btn btn-outline-secondary"
                (click)="goToPreviousTab()">
                <i class="fas fa-arrow-left me-2"></i>
                Anterior
              </button>
              
              <button 
                type="button" 
                class="btn btn-outline-danger"
                (click)="cancel()"
                [disabled]="isSaving">
                <i class="fas fa-times me-2"></i>
                Cancelar
              </button>
            </div>
            
            <div class="step-info">
              Passo {{ getCurrentTabIndex() + 1 }} de {{ availableTabs.length }}
            </div>
            
            <div class="d-flex gap-2">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="goToNextTab()"
                *ngIf="!isLastTab()">
                Próximo
                <i class="fas fa-arrow-right ms-2"></i>
              </button>
              
              <button 
                type="button" 
                class="btn btn-success"
                (click)="save()"
                [disabled]="!isFormValid() || isSaving"
                *ngIf="isLastTab()">
                <i class="fas fa-save me-2"></i>
                {{ isEditMode ? 'Atualizar' : 'Salvar' }}
                <span *ngIf="isSaving" class="spinner-border spinner-border-sm ms-2" role="status"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
